import { render, staticRenderFns } from "./WebhooksModal.vue?vue&type=template&id=6bcbe824&"
import script from "./WebhooksModal.vue?vue&type=script&lang=js&"
export * from "./WebhooksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports